var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgDistributionOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / 18 / Distribution",
    clipPath: "url(#clip0_35709_65946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60476 2.53972C1.319 2.885 1.06574 3.25817 0.849676 3.65454C0.307879 4.64848 0 5.78828 0 7C0 10.866 3.13401 14 7 14C8.21172 14 9.35152 13.6921 10.3455 13.1503C10.7418 12.9343 11.115 12.681 11.4603 12.3952L1.60476 2.53972ZM1.83438 4.63924C1.50538 5.35778 1.32222 6.15685 1.32222 7C1.32222 10.1358 3.86425 12.6778 7 12.6778C7.84315 12.6778 8.64221 12.4946 9.36075 12.1656L1.83438 4.63924Z",
    fill: "var(--secondary-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53972 1.60477C3.75084 0.602395 5.30507 0 7 0C8.69493 0 10.2492 0.602394 11.4603 1.60476L7 6.06505L2.53972 1.60477Z",
    fill: "var(--secondary-6)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3952 11.4603C12.681 11.115 12.9343 10.7418 13.1503 10.3455C13.6921 9.35153 14 8.21172 14 7C14 5.78828 13.6921 4.64847 13.1503 3.65453C12.9343 3.25817 12.681 2.885 12.3952 2.53972L7.93496 7L12.3952 11.4603ZM12.1656 9.36076C12.4946 8.64222 12.6778 7.84316 12.6778 7C12.6778 6.15684 12.4946 5.35778 12.1656 4.63924L9.80486 7L12.1656 9.36076Z",
    fill: "var(--secondary-6)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35709_65946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "var(--white)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributionOutlined);
export default __webpack_public_path__ + "static/media/distributionOutlined.8521895e2ab42a1339e756890b5950f8.svg";
export { ForwardRef as ReactComponent };